module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Sign In</h3>  \r\n    <p>Click Sign In at the top right. You will need a JustisOne subscription and your email address and password.</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-signin.html
// module id = 385
// module chunks = 1